<template>
    <div class="tips m-b-20 flex-row">
        <div class="item" v-for="(item, index) in list" :key="index" @click="viewPage(item)">
            <img :src="item.img" alt="">
            <p>{{item.name}}</p>
        </div>
    </div>
</template>
<script>
import contract from '@/assets/img/合同@3x.png';
import receiving from '@/assets/img/收货@3x.png';
import repair from '@/assets/img/报修@3x.png';
import order from '@/assets/img/订单@3x.png';
export default {
    data(){
        return {
            contract,
            receiving,
            repair,
            order,
            list:[
                {name: '待签合同', img: contract, type: 3 },
                {name: '待收货', img: receiving, type: 4},
                {name: '报修报修', img: repair, type: 2},
                {name: '全部订单', img: order, type: 1}
            ]
        } 
    },
    methods:{
        viewPage(item){
            if (item.type == 1) {
                this.$router.push({path:'/order'})
            } else if (item.type == 2) {
                this.$router.push({path:'/myContract'})
            } else if (item.type == 3) {
                this.$router.push({path:'/contractList'})
            } else if(item.type == 4){
                this.$router.push({path:'/orderReceived'})
            }
        }
    }
}
</script>
<style lang="scss" scoped>
  .tips{
    height: 120px;
    background: $ffff;
    padding:  17px 70px 14px 70px; 
    align-items: flex-end;
    justify-content: space-between;
    .item{
        text-align: center;
        img{
            max-width: 53px;
            max-height: 51px;
        }
        p{
            margin-top: 15px;
            font-size:22px;
            color: $color-85;
        }
    }
  }
</style>


